import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { DownloadK8sAgentDataProviderFactory } from '../factory/DownloadK8sAgentDataProviderFactory';
import { DownloadK8sAgentBaseDataProvider } from '../dataProvider/DownloadK8sAgentBaseDataProvider';
import { DownloadK8sAgentData } from '../types/download-k8s-agent-data';

export class DownloadK8sAgentRepository extends BaseWebComponentRepository {
  public dataProviderFactory: DownloadK8sAgentDataProviderFactory;
  public dataProvider: DownloadK8sAgentBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new DownloadK8sAgentDataProviderFactory(),
    });
  }

  public async getK8sScriptData(companyId: string): Promise<DownloadK8sAgentData> {
    return await this.dataProvider.getK8sScriptData(companyId);
  }

  public async getAvailableCompanyIdsWithKspm(): Promise<string[]> {
    return await this.dataProvider.getAvailableCompanyIdsWithKspm();
  }
}
